/**
 * Minimal semantic-version comparison for the API compatibility check. Three numeric parts,
 * optional leading `v`, anything after `-` or `+` ignored. No dependency: the only consumer is a
 * startup diagnostic, and a malformed input must never throw there.
 */
const parse = (value: string): [number, number, number] | null => {
  const match = /^v?(\d+)\.(\d+)\.(\d+)/.exec(value.trim());
  if (!match) return null;
  return [Number(match[1]), Number(match[2]), Number(match[3])];
};

export const isSemver = (value: string): boolean => parse(value) !== null;

/** -1 if a < b, 0 if equal, 1 if a > b. Throws on a malformed input; callers check `isSemver` first. */
export const compareSemver = (a: string, b: string): -1 | 0 | 1 => {
  const pa = parse(a);
  const pb = parse(b);
  if (!pa || !pb) throw new Error(`Not a semantic version: ${!pa ? a : b}`);
  for (let i = 0; i < 3; i += 1) {
    if (pa[i] < pb[i]) return -1;
    if (pa[i] > pb[i]) return 1;
  }
  return 0;
};
